(function () {
  function init(root) {
    root.querySelectorAll('[data-location-reviews]').forEach(function (section) {
      if (section.dataset.reviewsReady) return;
      section.dataset.reviewsReady = 'true';
      var track = section.querySelector('.location-reviews__track');
      var controls = section.querySelector('.location-reviews__controls');
      var buttons = controls.querySelectorAll('button');
      function update() {
        controls.hidden = track.scrollWidth <= track.clientWidth + 2;
        buttons[0].disabled = track.scrollLeft <= 2;
        buttons[1].disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
      }
      buttons.forEach(function (button) {
        button.addEventListener('click', function () {
          var card = track.querySelector('.review-card');
          var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
          track.scrollBy({ left: Number(button.dataset.reviewDirection) * (card.getBoundingClientRect().width + gap), behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
        });
      });
      track.addEventListener('scroll', update, { passive: true });
      new ResizeObserver(update).observe(track);
      update();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
